import { render, staticRenderFns } from "./IconBirth.vue?vue&type=template&id=281898f0&"
import script from "./IconBirth.vue?vue&type=script&lang=js&"
export * from "./IconBirth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports